const Spinner = ({ text = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div className="relative flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-4 border-primary-2 opacity-20" />
        <div className="absolute w-10 h-10 rounded-full border-4 border-primary-2 animate-ping opacity-60" />
      </div>

      <p className="text-sm text-gray-500 font-medium tracking-wide">
        {text}
      </p>
    </div>
  );
};

export default Spinner;
